import { render, staticRenderFns } from "./InterList.vue?vue&type=template&id=1c946a6d&scoped=true&"
import script from "./InterList.vue?vue&type=script&lang=js&"
export * from "./InterList.vue?vue&type=script&lang=js&"
import style0 from "./InterList.vue?vue&type=style&index=0&id=1c946a6d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c946a6d",
  null
  
)

export default component.exports